import Vue from 'vue'
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  bootstrap: false,
});